<div class="card-container" (click)="redirect($event)">
  <img [src]="image" [alt]="label" />
  <div class="label-container">
    <span class="label">{{ label }}</span>
  </div>
</div>
